module.exports = __webpack_public_path__ + "assets/img/guangyao.3257cd82.png";